import { render, staticRenderFns } from "./ParentCerts.vue?vue&type=template&id=6de7fce2&"
import script from "./ParentCerts.vue?vue&type=script&lang=js&"
export * from "./ParentCerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports